export const validateInputs = (inputs) => {
  let emailValid = validateEMailFormat(inputs.email);
  let passwordValid = true;
  let passwordConfirmValid = true;
  let regCodeValid = false;
  if (inputs["regCode"] !== undefined) {
    regCodeValid = validateRegCode(inputs.regCode);
  }
  if (inputs["password"] !== undefined) {
    passwordValid = validatePassword(inputs.password);
  }
  if (inputs["passwordConfirm"] !== undefined)
    passwordConfirmValid = validatePasswordConfirm(
      inputs.password,
      inputs.passwordConfirm,
    );

  return { regCodeValid, emailValid, passwordValid, passwordConfirmValid };
};

const validateEMailFormat = (email) => {
  let pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
  );
  return pattern.test(email);
};
export const validateRegCode = (regCode) => regCode.length >= 8;
export const validatePassword = (password) => password.length >= 8;

export const validatePasswordConfirm = (password, passwordConfirm) =>
  password === passwordConfirm;
